module.exports = __webpack_public_path__ + "static/media/Roy_Landers.ecf96a7c.png";